import React from "react"


export default function RescuerSearchInfo({search, rescuers}) {


    return <div className="info">
        <h2>Vodič za pretragu {rescuers?.length} korisnika</h2>
        
        <p>Postoje dva načina za pretragu korisnika:</p>
        <ol>
            <li><strong>Standardni:</strong> Možete direktno uneti ključne reči ili kriterijume opisane ispod.</li>
            <li><strong>AI:</strong> Možete uneti opis onoga što tražite, na primer:
                <ul>
                    <li className="example" onClick={() => search("Članovi upravnog odbora koji su završili kurs između 2010. i 2020. godine")}>Članovi upravnog odbora koji su završili kurs između 2010. i 2020. godine</li>
                    <li className="example" onClick={() => search("Treba mi magacioner")}>Treba mi magacioner</li>
                    <li className="example" onClick={() => search("Tečajci sa položenim skijanjem")}>Tečajci sa položenim skijanjem</li>
                </ul>
                Nakon toga, kliknite na štapić kako bi AI generisao upit.
            </li>
        </ol>
        
        <hr/>
                
        <h3>Osnovna pretraga</h3>
        <p>Unesite ključnu reč da biste pretraživali sve korisničke podatke.</p>
        <ul>
            <li><code>marko</code> → Pronalazi korisnike sa "marko" u bilo kom pretraživom polju.</li>
            <li><code>beograd</code> → Pronalazi korisnike iz Beograda.</li>
            <li><code>"novi sad"</code> → Pronalazi korisnike iz Novog Sada.</li>
        </ul>
        
        <h3>Pretraga po tagovima</h3>
        <p>Koristite <code>tag:</code> ili <code>#</code> za pretragu korisnika po tagovima, ili izaberite tag sa spiska dole.</p>
        <ul>
            <li><code>tag:upravni-odbor</code> → Pronalazi korisnike sa tagom "upravni-odbor".</li>
            <li><code>#ski-instruktor</code> → Pronalazi korisnike sa tagom "ski-instruktor".</li>
        </ul>
        
        <h3>Pretraga po određenom polju</h3>
        <p>
            Ako polje nije navedeno, pretražuje se po svim poljima. Ako je potrebno pretraživati određeno polje, navede se <code>polje:vrednost</code>.
            Dostupna polja za pretragu su: <code>username</code>, <code>given_name</code>, <code>family_name</code>, <code>nickname</code>, <code>gss_id</code>, <code>city</code>, <code>station</code>, <code>phone_number</code>, <code>ski</code>, <code>coef</code>, <code>rank</code>, <code>admission_year</code>.
        </p>
        <ul>
            <li><code>station:"novi sad"</code> → Pronalazi članove stanice Novi Sad.</li>
            <li><code>username:392</code> → Pronalazi korisnike sa korisničkim imenom "392" (isto što i <code>gss_id:392</code>).</li>
            <li><code>city:subotica</code> → Pronalazi korisnike iz Subotice.</li>
        </ul>
        
        <h3>Numerička poređenja</h3>
        <p>Koristite operatore poređenja (<code>&gt;</code>, <code>&lt;</code>, <code>&gt;=</code>, <code>&lt;=</code>, <code>:</code>) za numerička polja.</p>
        <ul>
            <li><code>rank&lt;30</code> → Pronalazi korisnike sa rangom manjim od 30.</li>
            <li><code>coef&gt;=0.5</code> → Pronalazi korisnike sa koeficijentom 0.5 ili višim.</li>
            <li><code>admission_year:2020</code> → Pronalazi korisnike primljene 2020. godine.</li>
        </ul>
        
        <h3>Pretraga po zvanјima</h3>
        <p>Pretraživanje spasilaca po zvanјima u domenima: <code>ski</code>, <code>vu</code> i <code>opu</code>.</p>
        <p>Zvanјa: <code>pripravnik</code>, <code>spasilac</code>, <code>vođa_tima</code>, <code>instruktor</code>.</p>
        <ul>
            <li><code>ski_level:spasilac</code> → Spasioci sa zvanјem "spasilac" na skijaškim terenima.</li>
            <li><code>ski_level&gt;=vođa_tima</code> → Spasioci sa zvanјem "vođa_tima" ili "instruktor" na skijaškim terenima.</li>
            <li><code>vu_level&lt;instruktor</code> → Spasioci sa zvanјem ispod "instruktor" u vertikalnim uslovima.</li>
            <li><code>has:opu_level</code> → Spasioci koji imaju bilo koje zvanјe u opštim planinskim uslovima.</li>
            <li><code>ski_level:inst</code> → Može se koristiti skraćenica po početku reči (pronalazi "instruktor").</li>
        </ul>

        <h3>Specijalni atributi</h3>
        <p>Postoji i nekoliko specijalnih kriterijuma za pretragu:</p>
        <ul>
            <li><code>has:licence</code> → Spasioci sa overenom licencom.</li>
            <li><code>has:ski</code> → Spasioci sa položenim skijanjem.</li>
            <li><code>has:membership</code> → Spasioci sa plaćenom godišnjom članarinom.</li>
        </ul>
        
        <h3>Kombinovanje uslova</h3>
        <p>Više unetih pojmova podrazumeva da su svi ispunjeni.</p>
        <ul>
            <li><code>city:"novi sad" tag:načelnik-stanice</code> → Pronalazi korisnike iz Novog Sada koji su takođe označeni kao "načelnik-stanice".</li>
            <li><code>rank&gt;20 admission_year&lt;2020</code> → Pronalazi korisnike sa rangom iznad 20 primljenim pre 2020. godine.</li>
            <li><code>admission_year&gt;=2019 admission_year&lt;=2021</code> → Pronalazi korisnike koji su primljeni između 2019. i 2021. godine.</li>
            <li><code>nikola city:niš</code> → Pronalazi korisnike sa imenom "Nikola" koji su iz Niša.</li>
        </ul>
                
        <p>Za preciznu pretragu koristite konkretna polja i operatore. Srećno pretraživanje!</p>
    </div>
}